//= Functions & Modules
// Own
import { DialogsSystem } from '../components/DialogsSystem';

export function setDialogsSystem(dialogsSystem: DialogsSystem) {
    window.g_dialogsSystem = dialogsSystem;
}
